export default (function (_ref) {
  var colors = _ref.colors;
  return {
    base: {
      fontSize: '14px',
      lineHeight: '17px',
      color: colors.secondary,
      textDecoration: 'underline',
      cursor: 'pointer',
      transition: 'color .2s',
      '& svg': {
        fill: colors.secondary,
        transition: 'fill .2s'
      },
      '&:hover, &:active': {
        color: colors.secondaryDarker,
        textDecoration: 'underline',
        '& svg': {
          fill: colors.secondaryDarker
        }
      }
    },
    icon: {
      marginRight: '10px',
      width: '14px',
      height: '14px',
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    icon__large: {
      width: '22px',
      height: '22px'
    },
    externalIcon: {
      display: 'inline-block',
      marginLeft: '5px',
      '& svg': {
        width: '10px',
        height: '10px'
      }
    },
    disabled: {
      cursor: 'default',
      pointerEvents: 'none',
      userSelect: 'none',
      color: colors.monotone3,
      '& svg': {
        fill: colors.monotone3
      }
    },
    inverseColors: {
      color: colors.white,
      transition: 'opacity .2s',
      '& svg': {
        fill: colors.white,
        transition: 'opacity .2s'
      },
      '&:hover, &:active': {
        color: colors.white,
        opacity: 0.8,
        '& svg': {
          fill: colors.white,
          opacity: 0.8
        }
      },
      '&$disabled': {
        opacity: 0.6
      }
    },
    large: {
      fontSize: '20px',
      lineHeight: '24px',
      fontWeight: 400
    }
  };
});